import Vue from "vue";
import VueRouter from "vue-router";

import SiteLayout from "@/views/layout/SiteLayout";

const ForgotpasswordView = () => import("@/views/site/ForgotpasswordView");
const ResetPasswordView = () => import("@/views/site/ResetPasswordView");
const CorporateUserResetPasswordView  = () => import("@/views/site/CorporateUserResetPasswordView");

const LoginView = () => import("@/views/site/LoginView");
const RegisterView = () => import("@/views/site/RegisterView");
const SuccessView = () => import("@/views/site/SuccessView");

//User Views

Vue.use(VueRouter);

var routes;
let userData = JSON.parse(localStorage.getItem("userData"));
var siteRoutesArray = [
  //Routes for sites
  { path: "", component: LoginView, name: "Login", meta: { title: "Login" } },
  {
    path: "/login",
    component: LoginView,
    name: "Login",
    meta: { title: "Login" },
  },
  // {
  //   path: "/register",
  //   component: RegisterView,
  //   name: "RegisterView",
  //   meta: { title: "RegisterView" },
  // },
  {
    path: "/success",
    component: SuccessView,
    name: "SuccessView",
    meta: { title: "SuccessView" },
  },
  {
    path: "/forgot-password",
    component: ForgotpasswordView,
    name: "ForgotpasswordView",
    meta: { title: "Forgot Password" },
  },
  {
    path: "/password/reset/*",
    component: ResetPasswordView,
    name: "ResetPasswordView",
    meta: { title: "Reset Password" },
  },
  {
    path: "/password-reset/*",
    component: CorporateUserResetPasswordView ,
    name: "CorporateUserResetPasswordView",
    meta: { title: "Corporate User Reset Password View" },
  },
];

routes = [
  {
    path: "/",
    component: SiteLayout,
    children: siteRoutesArray,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.PUBLIC_PATH,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
